"use server";
import { cookies, headers } from "next/headers";
import "server-only";

interface AuthReturnType {
  isAuthenticated: boolean;
  parsedUser?: unknown;
}

export async function useAuth(): Promise<AuthReturnType> {
  const cookieStore = await cookies();
  const [authToken, refreshToken]: Array<string | undefined> = [
    cookieStore.get("authtoken")?.value,
    cookieStore.get("refreshToken")?.value,
  ];

  return {
    isAuthenticated: false,
    parsedUser: null,
  };
}
